import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";

/**
 * Represents all of the metadata about a user setting.
 */

/**
 * A base class that implements user settings functionality.
 */
export class AbstractUserSetting {
  constructor(key) {
    _defineProperty(this, "description", undefined);
    _defineProperty(this, "defaultValue", undefined);
    _defineProperty(this, "requiresReload", false);
    _defineProperty(this, "_value", null);
    this.key = key;
  }
  get isAvailable() {
    return true;
  }
  async initialize() {
    if (this._value !== null) {
      return false;
    }
    const currentValue = await AbWebServices.userSettingsService.storage.getValue(this.key);
    this._value = currentValue || undefined;
    return true;
  }
  get value() {
    if (!this._value) {
      return this.defaultValue;
    }
    return this._value;
  }
  async setValue(value) {
    if (value === this.defaultValue) {
      this.removeValue();
    } else {
      await AbWebServices.userSettingsService.storage.setValue(this.key, value);
      this._value = value;
      this.onValueChange(value);
    }
  }
  onValueChange(value) {
    // Do nothing by default
  }
  async removeValue() {
    await AbWebServices.userSettingsService.storage.removeValue(this.key);
    this._value = undefined;
    this.onValueChange(this.value);
  }
}
//# sourceMappingURL=UserSetting.js.map
